import React from 'react';
import { Link, NavLink } from "react-router-dom";
import MobileMenu from './MobileMenu';

const Nav = () => {
    return (
        <>
            <div className="main-menu__inner">
                <MobileMenu />
                <ul className="main-menu__list">
                    <li>
                        <NavLink
                            className="freshswfl-home-link"
                            to={process.env.PUBLIC_URL + `/`}
                            aria-label="Home"
                            title="Home"
                        >
                            <span className="material-symbols-outlined" aria-hidden="true">home</span>
                            <span className="sr-only">Home</span>
                        </NavLink>
                    </li>
                    <li className="dropdown mega-menu">
                        <Link to={process.env.PUBLIC_URL + `/browse`} aria-haspopup="true">
                            Directory
                            <span className="material-symbols-outlined freshswfl-nav-chevron" aria-hidden="true">expand_more</span>
                        </Link>
                        <div className="mega-menu__panel" role="menu" aria-label="Directory">
                            <div className="mega-menu__panel-inner">
                                <div className="mega-menu__grid">
                                    <div className="mega-menu__col">
                                        <p className="mega-menu__title">Browse</p>
                                        <div className="mega-menu__items">
                                            <Link to={process.env.PUBLIC_URL + `/browse`} className="mega-menu__item" role="menuitem">
                                                <span className="mega-menu__item-icon" aria-hidden="true">
                                                    <span className="material-symbols-outlined">grid_view</span>
                                                </span>
                                                <span className="mega-menu__item-text">
                                                    <span className="mega-menu__item-label">Browse All</span>
                                                    <span className="mega-menu__item-desc">All local listings, one place</span>
                                                </span>
                                            </Link>
                                            <Link to={process.env.PUBLIC_URL + `/map`} className="mega-menu__item" role="menuitem">
                                                <span className="mega-menu__item-icon" aria-hidden="true">
                                                    <span className="material-symbols-outlined">map</span>
                                                </span>
                                                <span className="mega-menu__item-text">
                                                    <span className="mega-menu__item-label">Map View</span>
                                                    <span className="mega-menu__item-desc">Explore nearby spots on a map</span>
                                                </span>
                                            </Link>
                                            <Link to={process.env.PUBLIC_URL + `/search`} className="mega-menu__item" role="menuitem">
                                                <span className="mega-menu__item-icon" aria-hidden="true">
                                                    <span className="material-symbols-outlined">search</span>
                                                </span>
                                                <span className="mega-menu__item-text">
                                                    <span className="mega-menu__item-label">Search</span>
                                                    <span className="mega-menu__item-desc">Find farms, markets, and more</span>
                                                </span>
                                            </Link>
                                        </div>
                                    </div>

                                    <div className="mega-menu__col">
                                        <p className="mega-menu__title">Categories</p>
                                        <div className="mega-menu__items">
                                            <Link to={process.env.PUBLIC_URL + `/category/farms`} className="mega-menu__item" role="menuitem">
                                                <span className="mega-menu__item-icon" aria-hidden="true">
                                                    <span className="material-symbols-outlined">agriculture</span>
                                                </span>
                                                <span className="mega-menu__item-text">
                                                    <span className="mega-menu__item-label">Farms</span>
                                                    <span className="mega-menu__item-desc">Local growers and producers</span>
                                                </span>
                                            </Link>
                                            <Link to={process.env.PUBLIC_URL + `/category/farmers-markets`} className="mega-menu__item" role="menuitem">
                                                <span className="mega-menu__item-icon" aria-hidden="true">
                                                    <span className="material-symbols-outlined">storefront</span>
                                                </span>
                                                <span className="mega-menu__item-text">
                                                    <span className="mega-menu__item-label">Farmers Markets</span>
                                                    <span className="mega-menu__item-desc">Weekly and seasonal markets</span>
                                                </span>
                                            </Link>
                                            <Link to={process.env.PUBLIC_URL + `/category/csa-programs`} className="mega-menu__item" role="menuitem">
                                                <span className="mega-menu__item-icon" aria-hidden="true">
                                                    <span className="material-symbols-outlined">inventory_2</span>
                                                </span>
                                                <span className="mega-menu__item-text">
                                                    <span className="mega-menu__item-label">CSA Programs</span>
                                                    <span className="mega-menu__item-desc">Subscription produce boxes</span>
                                                </span>
                                            </Link>
                                        </div>
                                    </div>

                                    <div className="mega-menu__col">
                                        <p className="mega-menu__title">Tools</p>
                                        <div className="mega-menu__items">
                                            <Link to={process.env.PUBLIC_URL + `/seasonal`} className="mega-menu__item" role="menuitem">
                                                <span className="mega-menu__item-icon" aria-hidden="true">
                                                    <span className="material-symbols-outlined">calendar_month</span>
                                                </span>
                                                <span className="mega-menu__item-text">
                                                    <span className="mega-menu__item-label">Seasonal Guide</span>
                                                    <span className="mega-menu__item-desc">What’s in season right now</span>
                                                </span>
                                            </Link>
                                            <Link to={process.env.PUBLIC_URL + `/favorites`} className="mega-menu__item" role="menuitem">
                                                <span className="mega-menu__item-icon" aria-hidden="true">
                                                    <span className="material-symbols-outlined">favorite</span>
                                                </span>
                                                <span className="mega-menu__item-text">
                                                    <span className="mega-menu__item-label">Favorites</span>
                                                    <span className="mega-menu__item-desc">Save spots you love</span>
                                                </span>
                                            </Link>
                                            <Link to={process.env.PUBLIC_URL + `/compare`} className="mega-menu__item" role="menuitem">
                                                <span className="mega-menu__item-icon" aria-hidden="true">
                                                    <span className="material-symbols-outlined">compare_arrows</span>
                                                </span>
                                                <span className="mega-menu__item-text">
                                                    <span className="mega-menu__item-label">Compare</span>
                                                    <span className="mega-menu__item-desc">Compare vendors side-by-side</span>
                                                </span>
                                            </Link>
                                        </div>
                                    </div>

                                    <div className="mega-menu__col mega-menu__col--muted">
                                        <p className="mega-menu__title">Quick</p>
                                        <div className="mega-menu__items">
                                            <Link to={process.env.PUBLIC_URL + `/events`} className="mega-menu__item" role="menuitem">
                                                <span className="mega-menu__item-icon" aria-hidden="true">
                                                    <span className="material-symbols-outlined">event</span>
                                                </span>
                                                <span className="mega-menu__item-text">
                                                    <span className="mega-menu__item-label">Events</span>
                                                    <span className="mega-menu__item-desc">Markets, pop-ups, and community</span>
                                                </span>
                                            </Link>
                                            <Link to={process.env.PUBLIC_URL + `/about`} className="mega-menu__item" role="menuitem">
                                                <span className="mega-menu__item-icon" aria-hidden="true">
                                                    <span className="material-symbols-outlined">info</span>
                                                </span>
                                                <span className="mega-menu__item-text">
                                                    <span className="mega-menu__item-label">About</span>
                                                    <span className="mega-menu__item-desc">Our mission and how it works</span>
                                                </span>
                                            </Link>
                                            <Link to={process.env.PUBLIC_URL + `/contact`} className="mega-menu__item" role="menuitem">
                                                <span className="mega-menu__item-icon" aria-hidden="true">
                                                    <span className="material-symbols-outlined">call</span>
                                                </span>
                                                <span className="mega-menu__item-text">
                                                    <span className="mega-menu__item-label">Contact</span>
                                                    <span className="mega-menu__item-desc">Get in touch</span>
                                                </span>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>

                    {/* Recipes Mega Menu */}
                    <li className="dropdown mega-menu">
                        <Link to={process.env.PUBLIC_URL + `/recipes`} aria-haspopup="true">
                            Recipes
                            <span className="material-symbols-outlined freshswfl-nav-chevron" aria-hidden="true">expand_more</span>
                        </Link>
                        <div className="mega-menu__panel" role="menu" aria-label="Recipes">
                            <div className="mega-menu__panel-inner">
                                <div className="mega-menu__grid">
                                    <div className="mega-menu__col">
                                        <p className="mega-menu__title">Browse Recipes</p>
                                        <div className="mega-menu__items">
                                            <Link to={process.env.PUBLIC_URL + `/recipes`} className="mega-menu__item" role="menuitem">
                                                <span className="mega-menu__item-icon" aria-hidden="true">
                                                    <span className="material-symbols-outlined">restaurant</span>
                                                </span>
                                                <span className="mega-menu__item-text">
                                                    <span className="mega-menu__item-label">All Recipes</span>
                                                    <span className="mega-menu__item-desc">Browse all 52 local recipes</span>
                                                </span>
                                            </Link>
                                            <Link to={process.env.PUBLIC_URL + `/recipes?filter=quick`} className="mega-menu__item" role="menuitem">
                                                <span className="mega-menu__item-icon" aria-hidden="true">
                                                    <span className="material-symbols-outlined">timer</span>
                                                </span>
                                                <span className="mega-menu__item-text">
                                                    <span className="mega-menu__item-label">Quick Recipes</span>
                                                    <span className="mega-menu__item-desc">Ready in 30 minutes or less</span>
                                                </span>
                                            </Link>
                                            <Link to={process.env.PUBLIC_URL + `/recipes?filter=seasonal`} className="mega-menu__item" role="menuitem">
                                                <span className="mega-menu__item-icon" aria-hidden="true">
                                                    <span className="material-symbols-outlined">eco</span>
                                                </span>
                                                <span className="mega-menu__item-text">
                                                    <span className="mega-menu__item-label">Seasonal Recipes</span>
                                                    <span className="mega-menu__item-desc">Using what's in season now</span>
                                                </span>
                                            </Link>
                                        </div>
                                    </div>

                                    <div className="mega-menu__col">
                                        <p className="mega-menu__title">By Diet</p>
                                        <div className="mega-menu__items">
                                            <Link to={process.env.PUBLIC_URL + `/recipes?diet=vegetarian`} className="mega-menu__item" role="menuitem">
                                                <span className="mega-menu__item-icon" aria-hidden="true">
                                                    <span className="material-symbols-outlined">potted_plant</span>
                                                </span>
                                                <span className="mega-menu__item-text">
                                                    <span className="mega-menu__item-label">Vegetarian</span>
                                                    <span className="mega-menu__item-desc">Plant-based recipes</span>
                                                </span>
                                            </Link>
                                            <Link to={process.env.PUBLIC_URL + `/recipes?diet=vegan`} className="mega-menu__item" role="menuitem">
                                                <span className="mega-menu__item-icon" aria-hidden="true">
                                                    <span className="material-symbols-outlined">spa</span>
                                                </span>
                                                <span className="mega-menu__item-text">
                                                    <span className="mega-menu__item-label">Vegan</span>
                                                    <span className="mega-menu__item-desc">No animal products</span>
                                                </span>
                                            </Link>
                                            <Link to={process.env.PUBLIC_URL + `/recipes?diet=gluten-free`} className="mega-menu__item" role="menuitem">
                                                <span className="mega-menu__item-icon" aria-hidden="true">
                                                    <span className="material-symbols-outlined">grain</span>
                                                </span>
                                                <span className="mega-menu__item-text">
                                                    <span className="mega-menu__item-label">Gluten-Free</span>
                                                    <span className="mega-menu__item-desc">Wheat-free options</span>
                                                </span>
                                            </Link>
                                        </div>
                                    </div>

                                    <div className="mega-menu__col">
                                        <p className="mega-menu__title">By Difficulty</p>
                                        <div className="mega-menu__items">
                                            <Link to={process.env.PUBLIC_URL + `/recipes?difficulty=easy`} className="mega-menu__item" role="menuitem">
                                                <span className="mega-menu__item-icon" aria-hidden="true">
                                                    <span className="material-symbols-outlined">rocket_launch</span>
                                                </span>
                                                <span className="mega-menu__item-text">
                                                    <span className="mega-menu__item-label">Easy Recipes</span>
                                                    <span className="mega-menu__item-desc">Perfect for beginners</span>
                                                </span>
                                            </Link>
                                            <Link to={process.env.PUBLIC_URL + `/recipes?difficulty=medium`} className="mega-menu__item" role="menuitem">
                                                <span className="mega-menu__item-icon" aria-hidden="true">
                                                    <span className="material-symbols-outlined">star_half</span>
                                                </span>
                                                <span className="mega-menu__item-text">
                                                    <span className="mega-menu__item-label">Medium Recipes</span>
                                                    <span className="mega-menu__item-desc">Some cooking experience</span>
                                                </span>
                                            </Link>
                                            <Link to={process.env.PUBLIC_URL + `/recipes?difficulty=hard`} className="mega-menu__item" role="menuitem">
                                                <span className="mega-menu__item-icon" aria-hidden="true">
                                                    <span className="material-symbols-outlined">award_star</span>
                                                </span>
                                                <span className="mega-menu__item-text">
                                                    <span className="mega-menu__item-label">Advanced Recipes</span>
                                                    <span className="mega-menu__item-desc">For skilled cooks</span>
                                                </span>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>

                    {/* Guides Mega Menu */}
                    <li className="dropdown mega-menu">
                        <Link to={process.env.PUBLIC_URL + `/seasonal-guides`} aria-haspopup="true">
                            Guides
                            <span className="material-symbols-outlined freshswfl-nav-chevron" aria-hidden="true">expand_more</span>
                        </Link>
                        <div className="mega-menu__panel" role="menu" aria-label="Guides">
                            <div className="mega-menu__panel-inner">
                                <div className="mega-menu__grid">
                                    <div className="mega-menu__col">
                                        <p className="mega-menu__title">Seasonal Guides</p>
                                        <div className="mega-menu__items">
                                            <Link to={process.env.PUBLIC_URL + `/seasonal-guides`} className="mega-menu__item" role="menuitem">
                                                <span className="mega-menu__item-icon" aria-hidden="true">
                                                    <span className="material-symbols-outlined">menu_book</span>
                                                </span>
                                                <span className="mega-menu__item-text">
                                                    <span className="mega-menu__item-label">All Seasonal Guides</span>
                                                    <span className="mega-menu__item-desc">Complete monthly guides</span>
                                                </span>
                                            </Link>
                                            <Link to={process.env.PUBLIC_URL + `/seasonal`} className="mega-menu__item" role="menuitem">
                                                <span className="mega-menu__item-icon" aria-hidden="true">
                                                    <span className="material-symbols-outlined">wb_sunny</span>
                                                </span>
                                                <span className="mega-menu__item-text">
                                                    <span className="mega-menu__item-label">What's In Season</span>
                                                    <span className="mega-menu__item-desc">Current month's produce</span>
                                                </span>
                                            </Link>
                                        </div>
                                    </div>

                                    <div className="mega-menu__col">
                                        <p className="mega-menu__title">Blog & Articles</p>
                                        <div className="mega-menu__items">
                                            <Link to={process.env.PUBLIC_URL + `/events`} className="mega-menu__item" role="menuitem">
                                                <span className="mega-menu__item-icon" aria-hidden="true">
                                                    <span className="material-symbols-outlined">article</span>
                                                </span>
                                                <span className="mega-menu__item-text">
                                                    <span className="mega-menu__item-label">All Blog Posts</span>
                                                    <span className="mega-menu__item-desc">Latest articles and tips</span>
                                                </span>
                                            </Link>
                                            <Link to={process.env.PUBLIC_URL + `/events?category=guides`} className="mega-menu__item" role="menuitem">
                                                <span className="mega-menu__item-icon" aria-hidden="true">
                                                    <span className="material-symbols-outlined">local_florist</span>
                                                </span>
                                                <span className="mega-menu__item-text">
                                                    <span className="mega-menu__item-label">Farm Guides</span>
                                                    <span className="mega-menu__item-desc">How to shop local</span>
                                                </span>
                                            </Link>
                                            <Link to={process.env.PUBLIC_URL + `/events?category=tips`} className="mega-menu__item" role="menuitem">
                                                <span className="mega-menu__item-icon" aria-hidden="true">
                                                    <span className="material-symbols-outlined">lightbulb</span>
                                                </span>
                                                <span className="mega-menu__item-text">
                                                    <span className="mega-menu__item-label">Cooking Tips</span>
                                                    <span className="mega-menu__item-desc">Kitchen know-how</span>
                                                </span>
                                            </Link>
                                        </div>
                                    </div>

                                    <div className="mega-menu__col mega-menu__col--muted">
                                        <p className="mega-menu__title">Resources</p>
                                        <div className="mega-menu__items">
                                            <Link to={process.env.PUBLIC_URL + `/guide/shopping-at-farmers-markets`} className="mega-menu__item" role="menuitem">
                                                <span className="mega-menu__item-icon" aria-hidden="true">
                                                    <span className="material-symbols-outlined">shopping_basket</span>
                                                </span>
                                                <span className="mega-menu__item-text">
                                                    <span className="mega-menu__item-label">Shopping Guide</span>
                                                    <span className="mega-menu__item-desc">Markets like a pro</span>
                                                </span>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>

                    {/* Produce Mega Menu */}
                    <li className="dropdown mega-menu">
                        <Link to={process.env.PUBLIC_URL + `/produce-directory`} aria-haspopup="true">
                            Produce
                            <span className="material-symbols-outlined freshswfl-nav-chevron" aria-hidden="true">expand_more</span>
                        </Link>
                        <div className="mega-menu__panel" role="menu" aria-label="Produce">
                            <div className="mega-menu__panel-inner">
                                <div className="mega-menu__grid">
                                    <div className="mega-menu__col">
                                        <p className="mega-menu__title">Browse Produce</p>
                                        <div className="mega-menu__items">
                                            <Link to={process.env.PUBLIC_URL + `/produce-directory`} className="mega-menu__item" role="menuitem">
                                                <span className="mega-menu__item-icon" aria-hidden="true">
                                                    <span className="material-symbols-outlined">nutrition</span>
                                                </span>
                                                <span className="mega-menu__item-text">
                                                    <span className="mega-menu__item-label">All Produce</span>
                                                    <span className="mega-menu__item-desc">Complete produce guide</span>
                                                </span>
                                            </Link>
                                            <Link to={process.env.PUBLIC_URL + `/seasonal`} className="mega-menu__item" role="menuitem">
                                                <span className="mega-menu__item-icon" aria-hidden="true">
                                                    <span className="material-symbols-outlined">schedule</span>
                                                </span>
                                                <span className="mega-menu__item-text">
                                                    <span className="mega-menu__item-label">In Season Now</span>
                                                    <span className="mega-menu__item-desc">Fresh and available</span>
                                                </span>
                                            </Link>
                                        </div>
                                    </div>

                                    <div className="mega-menu__col">
                                        <p className="mega-menu__title">By Category</p>
                                        <div className="mega-menu__items">
                                            <Link to={process.env.PUBLIC_URL + `/produce?category=fruit`} className="mega-menu__item" role="menuitem">
                                                <span className="mega-menu__item-icon" aria-hidden="true">
                                                    <span className="material-symbols-outlined">skillet</span>
                                                </span>
                                                <span className="mega-menu__item-text">
                                                    <span className="mega-menu__item-label">Fruits</span>
                                                    <span className="mega-menu__item-desc">Fresh local fruits</span>
                                                </span>
                                            </Link>
                                            <Link to={process.env.PUBLIC_URL + `/produce?category=vegetable`} className="mega-menu__item" role="menuitem">
                                                <span className="mega-menu__item-icon" aria-hidden="true">
                                                    <span className="material-symbols-outlined">dinner_dining</span>
                                                </span>
                                                <span className="mega-menu__item-text">
                                                    <span className="mega-menu__item-label">Vegetables</span>
                                                    <span className="mega-menu__item-desc">Garden vegetables</span>
                                                </span>
                                            </Link>
                                            <Link to={process.env.PUBLIC_URL + `/produce?category=herb`} className="mega-menu__item" role="menuitem">
                                                <span className="mega-menu__item-icon" aria-hidden="true">
                                                    <span className="material-symbols-outlined">yard</span>
                                                </span>
                                                <span className="mega-menu__item-text">
                                                    <span className="mega-menu__item-label">Herbs</span>
                                                    <span className="mega-menu__item-desc">Fresh herbs & spices</span>
                                                </span>
                                            </Link>
                                        </div>
                                    </div>

                                    <div className="mega-menu__col mega-menu__col--muted">
                                        <p className="mega-menu__title">Find Farms</p>
                                        <div className="mega-menu__items">
                                            <Link to={process.env.PUBLIC_URL + `/browse`} className="mega-menu__item" role="menuitem">
                                                <span className="mega-menu__item-icon" aria-hidden="true">
                                                    <span className="material-symbols-outlined">location_on</span>
                                                </span>
                                                <span className="mega-menu__item-text">
                                                    <span className="mega-menu__item-label">Where to Buy</span>
                                                    <span className="mega-menu__item-desc">Find local sources</span>
                                                </span>
                                            </Link>
                                            <Link to={process.env.PUBLIC_URL + `/category/farmers-markets`} className="mega-menu__item" role="menuitem">
                                                <span className="mega-menu__item-icon" aria-hidden="true">
                                                    <span className="material-symbols-outlined">storefront</span>
                                                </span>
                                                <span className="mega-menu__item-text">
                                                    <span className="mega-menu__item-label">Farmers Markets</span>
                                                    <span className="mega-menu__item-desc">Weekly markets</span>
                                                </span>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>

                    <li>
                        <NavLink to={process.env.PUBLIC_URL + `/events`}>Events</NavLink>
                    </li>
                    <li>
                        <NavLink to={process.env.PUBLIC_URL + `/about`}>About</NavLink>
                    </li>
                    <li>
                        <NavLink to={process.env.PUBLIC_URL + `/contact`}>Contact</NavLink>
                    </li>
                </ul>
            </div>
        </>
    )
}

export default Nav;


